/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HotelBookingResponseStatus } from './HotelBookingResponseStatus';
import {
    HotelBookingResponseStatusFromJSON,
    HotelBookingResponseStatusFromJSONTyped,
    HotelBookingResponseStatusToJSON,
    HotelBookingResponseStatusToJSONTyped,
} from './HotelBookingResponseStatus';
import type { Booking } from './Booking';
import {
    BookingFromJSON,
    BookingFromJSONTyped,
    BookingToJSON,
    BookingToJSONTyped,
} from './Booking';
import type { ItineraryCreation } from './ItineraryCreation';
import {
    ItineraryCreationFromJSON,
    ItineraryCreationFromJSONTyped,
    ItineraryCreationToJSON,
    ItineraryCreationToJSONTyped,
} from './ItineraryCreation';

/**
 * The response from a hotel booking request
 * @export
 * @interface HotelBookingResponse
 */
export interface HotelBookingResponse {
    /**
     * 
     * @type {ItineraryCreation}
     * @memberof HotelBookingResponse
     */
    itinerary?: ItineraryCreation;
    /**
     * 
     * @type {Booking}
     * @memberof HotelBookingResponse
     */
    booking?: Booking;
    /**
     * 
     * @type {number}
     * @memberof HotelBookingResponse
     */
    statusCode: number;
    /**
     * 
     * @type {HotelBookingResponseStatus}
     * @memberof HotelBookingResponse
     */
    status: HotelBookingResponseStatus;
    /**
     * 
     * @type {Error}
     * @memberof HotelBookingResponse
     */
    error?: Error;
    /**
     * 
     * @type {Array<Error>}
     * @memberof HotelBookingResponse
     */
    subErrors?: Array<Error>;
    /**
     * Present when the booking was refused pending a 3DS challenge (CARD_DECLINED). Complete the challenge with Stripe `handleNextAction(three_ds_client_secret)` and retry the booking — the retry re-verifies the intent server-side and proceeds.
     * @type {string}
     * @memberof HotelBookingResponse
     */
    threeDsClientSecret?: string | null;
}



/**
 * Check if a given object implements the HotelBookingResponse interface.
 */
export function instanceOfHotelBookingResponse(value: object): value is HotelBookingResponse {
    if (!('statusCode' in value) || value['statusCode'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function HotelBookingResponseFromJSON(json: any): HotelBookingResponse {
    return HotelBookingResponseFromJSONTyped(json, false);
}

export function HotelBookingResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): HotelBookingResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'itinerary': json['itinerary'] == null ? undefined : ItineraryCreationFromJSON(json['itinerary']),
        'booking': json['booking'] == null ? undefined : BookingFromJSON(json['booking']),
        'statusCode': json['status_code'],
        'status': HotelBookingResponseStatusFromJSON(json['status']),
        'error': json['error'] == null ? undefined : json['error'],
        'subErrors': json['sub_errors'] == null ? undefined : json['sub_errors'],
        'threeDsClientSecret': json['three_ds_client_secret'] == null ? undefined : json['three_ds_client_secret'],
    };
}

export function HotelBookingResponseToJSON(json: any): HotelBookingResponse {
    return HotelBookingResponseToJSONTyped(json, false);
}

export function HotelBookingResponseToJSONTyped(value?: HotelBookingResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'itinerary': ItineraryCreationToJSON(value['itinerary']),
        'booking': BookingToJSON(value['booking']),
        'status_code': value['statusCode'],
        'status': HotelBookingResponseStatusToJSON(value['status']),
        'error': value['error'],
        'sub_errors': value['subErrors'],
        'three_ds_client_secret': value['threeDsClientSecret'],
    };
}

